import { c as _c } from "react/compiler-runtime";
import type { ClassificationCategory } from '@repo/api-gw-sdk';
import { useMemo } from 'react';
import { useDAL } from '@/contexts/useDAL';
export const useClassificationCategories = () => {
  const dal = useDAL();
  const {
    data,
    isLoading
  } = dal.inventory.dataClasses.useCategories();
  const categories = useMemo<ClassificationCategory[]>(() => data?.categories ?? [], [data?.categories]);
  const lookup = useMemo<Record<string, ClassificationCategory>>(() => Object.fromEntries(categories.map(c => [c.name, c])), [categories]);
  return {
    categories,
    lookup,
    isLoading
  };
};
export const useDataClassFilterOptions = () => {
  const $ = _c(5);
  const {
    categories,
    isLoading
  } = useClassificationCategories();
  let t0;
  if ($[0] !== categories) {
    t0 = categories.map(_temp);
    $[0] = categories;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const options = t0;
  let t1;
  if ($[2] !== isLoading || $[3] !== options) {
    t1 = {
      options,
      isLoading
    };
    $[2] = isLoading;
    $[3] = options;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
function _temp(c) {
  return {
    id: c.name,
    name: c.name,
    description: c.description
  };
}